<template>
  <!-- <div
    class="login"
    :style="{
      height: fullHeight + 'px',
    }"
  > -->
  <div class="login">
    <div class="left">
      <!-- <h1>珑阁</h1> -->
    </div>
    <div class="max">
      <img src="@/assets/img/logo.png" alt="" />
      <div class="top">
        <h1 class="littlefont">奥赛德</h1>
      </div>
      <div class="code">
        <span v-html="'设&nbsp;&nbsp;备'"></span>
        <!-- <el-input
          v-model="equipment"
          clearable
          placeholder="请输入设备号"
          @focus="opensb"
          size="small"
        >
          <template slot="append">
            <img
              slot="append"
              src="@/assets/img/sm.png"
              alt=""
              @click="getSaoma"
              style="background: #faa"
            />
          </template>
        </el-input> -->
        <el-select
          v-model="equipment"
          filterable
          clearable
          size="mini"
          placeholder="请选择"
          @change="changeSbei"
        >
          <el-option
            v-for="item in machine"
            :key="item.index"
            :label="item.EQUIPMENTID"
            :value="item.EQUIPMENTID"
          />
        </el-select>
      </div>
      <div class="code">
        <i class="iconfont el-icon-s-custom ico1"></i>
        <el-input
          type="text"
          ref="bm"
          clearable
          v-model="loginForm.UserId"
          placeholder="请输入账号"
          @input="confirmFn"
          @focus="open"
        >
        </el-input>
      </div>
      <div class="code">
        <i class="iconfont el-icon-s-custom ico1"></i>
        <el-input type="text" ref="bm" disabled v-model="loginForm.UserName">
        </el-input>
      </div>
      <div class="code">
        <i class="iconfont el-icon-lock ico1"></i>
        <el-input
          placeholder="请输入密码"
          v-model="loginForm.Password"
          clearable
          show-password
          @change="confirmFn"
          @focus="openshow"
        ></el-input>
      </div>
      <div class="code">
        <i class="iconfont el-input__icon el-icon-date ico1"></i>
        <el-date-picker
          v-model="WorkerDate"
          type="date"
          clearable
          placeholder="选择日期"
          value-format="yyyyMMdd"
        >
        </el-date-picker>
      </div>
      <div class="btn">
        <el-button type="primary" @click="loginFn">登录</el-button>
      </div>
    </div>
    <!-- 扫码功能 -->
    <div class="code-reader-content" v-if="showvideo">
      <div class="page">
        <video ref="video" autoplay id="video"></video>
        <p v-if="videoInputDevicesArray.length == 0">{{ textContent }}</p>
      </div>
      <div class="scan-box">
        <div class="frame upper-left"></div>
        <div class="frame upper-right"></div>
        <div class="frame lower-right"></div>
        <div class="frame lower-left"></div>
        <div class="pointer-box">
          <div class="pointer"></div>
        </div>
        <div v-show="tipShow" class="tip">{{ tipMsg }}</div>
        <div class="btn-switch" @click="toggle">
          <span class="right" @click="colose()">关闭</span>
        </div>
      </div>
    </div>
    <Clavier v-if="show" :show="show" @updatekey="GetKeyVal"></Clavier>
    <Clavier v-if="show1" :show="show1" @getval="getval"></Clavier>
    <Clavier v-if="show2" :show="show2" @getval="getsbval"></Clavier>
  </div>
</template>

<script>
import { api } from "../api";
import { Notify } from "vant";
import storage from "../api/storage";
import orCodeSingle from "./orCode/orCodeSingle";
import localStorage from "../api/localStorage";
import Clavier from "./Clavier.vue";
// 引入插件
import { BrowserMultiFormatReader } from "@zxing/library";

export default {
  name: "LoginHJ",
  components: {
    orCodeSingle,
    Clavier,
  },
  data() {
    return {
      WorkerDate: "",
      // WorkerDate: new Date().getFullYear() + ((new Date().getMonth() + 1).toString().padStart(2, '0')) + (new Date().getDate().toString().padStart(2, '0')),
      // 关于扫码
      showvideo: false,
      codeReader: null,
      tipMsg: "正在尝试识别....",
      tipShow: true,
      textContent: undefined,
      videoInputDevicesArray: [],
      deviceId: "",
      isEswitch: false,
      timer: null,
      route: "",
      code: "",
      code2: "",
      isDisabled: true,
      fullscreen: false,
      value: false,
      inspector: [],
      CheckPersonId: "",
      CheckPersonName: "",
      option: [
        // {
        //   value: "/zhengjing",
        //   label: "整经工位",
        // },
        {
          value: "/zhizao",
          label: "织造车间",
        },
      ],
      equipment: "",
      machine: [],
      loginForm: {
        UserId: "",
        UserName: "",
        Password: "",
      },
      inspector: [],
      // 关于扫码
      orCodeValStatic: false,
      locationLayer: true,
      orCodeType: "",
      orCodeStaticVal: -1,
      // 键盘
      show: false,
      show2: false,
      show1: false,
      user: localStorage.getUser(),
    };
  },
  destroyed() {
    // this.codeReader.stopContinuousDecode();
    // this.codeReader.reset();
  },
  // watch: {
  //   $route: {
  //     handler() {
  //       this.user = storage.getUser();
  //     },
  //     // 深度观察监听
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  created() {
    this.GetEquipment();
    console.log(this.user);
  },
  mounted() {
    this.loginForm.UserId = storage.getUserInfo().UserId;
    this.loginForm.UserName = storage.getUserInfo().UserName;
    this.loginForm.Password = storage.getUserInfo().Password;
    // if (storage.getUser().Token) {
    //   this.loginFn();
    // }
    // this.machineId();
    // this.getcheckperson()
  },
  methods: {
    // 键盘
    GetKeyVal(val) {
      console.log(val);
      this.loginForm.UserId = val;
      this.getcheckperson();
    },
    getval(val) {
      this.loginForm.Password = val;
    },
    getsbval(val) {
      this.equipment = val;
    },
    opensb() {
      this.show2 = false;
      this.$nextTick(() => {
        this.show2 = true;
      });
    },
    open() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    openshow() {
      this.show1 = false;
      this.$nextTick(() => {
        this.show1 = true;
      });
    },
    // 检验员
    getcheckperson() {
      api.getpersonscan(this.loginForm.UserId).then((res) => {
        console.log(res.data);
        if (res.data.Enttity !== null) {
          this.loginForm.UserName = res.data.Enttity.PERSONNAME;
        } else {
          // this.loginForm.UserId = "";
          // this.loginForm.UserName = "";
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
          });
        }
      });
    },
    confirmFn() {
      this.getcheckperson();
    },
    // 扫任务书号
    getSaoma() {
      // console.log(1);
      this.showvideo = true;
      this.openScan();
      // console.log(2);
    },
    // 全屏
    fullScreenClick() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    // 机台
    // machineId() {
    //   let params = {
    //     Page: 1,
    //     PageSize: 50,
    //     Entity: {
    //       Code: "",
    //       Type: "YB",
    //     },
    //   };
    //   api.GetEquipmentList(this.$qs.stringify(params)).then((res) => {
    //     console.log(res.data);
    //     this.machine = res.data.Entities;
    //     // console.log(this.machine);
    //   });
    // },
    changeSbei(val) {
      console.log(val);
      // this.user.MachineId = val;
      this.GetEquipment();
    },
    GetEquipment() {
      let params = {
        EQUIPMENTID: this.equipment,
      };
      console.log(params);
      api.GetEquipment(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.machine = res.data;
      });
    },
    // 登录
    loginFn() {
      if (this.WorkerDate.length > 0) {
        // this.fullScreenClick()
        let params = {
          EQUIPMENTID: this.equipment,
          UserId: this.loginForm.UserId,
          Password: this.loginForm.Password,
        };
        console.log(params);
        api.login(this.$qs.stringify(params)).then((res) => {
          // 3bcp  4cp
          console.log(res.data);
          let data = res.data;
          if (data.Succeed) {
            let user = {};
            user = {
              UserId: this.loginForm.UserId,
              UserName: this.loginForm.UserName,
              Password: this.loginForm.UserId,
              PowerType: 0,
              Token: data.Token,
              PersonId: data.PersonId,
              PersonName: data.PersonName,
              UidName: this.loginForm.UserId + "," + this.loginForm.UserName,
              MachineId: this.equipment.trim(),
              WDate: this.WorkerDate,
            };
            storage.saveUser(user);
            localStorage.setUser(user);
            storage.saveUserInfo({
              UserId: this.loginForm.UserId,
              UserName: this.loginForm.UserName,
              UidName: this.loginForm.UserId + "," + this.loginForm.UserName,
              Password: this.loginForm.Password,
            });
            console.log(user);
            // console.log(this.route);
            // this.fullScreenClick()
            this.$router.replace("/zhizao");
          } else {
            Notify({ type: "danger", message: "账号或密码错误" });
          }
        });
      } else {
        return this.$message({
          message: "请选择日期",
          type: "warning",
        });
      }
    },
    openScan() {
      this.codeReader = new BrowserMultiFormatReader();
      console.log(this.codeReader);
      this.codeReader
        .getVideoInputDevices()
        .then(async (videoInputDevices) => {
          this.tipShow = true;
          this.tipMsg = "正在尝试识别....";
          this.videoInputDevicesArray = videoInputDevices;
          //
          console.log("获取到的摄像头", this.videoInputDevicesArray);
          if (this.videoInputDevicesArray.length > 1) {
            this.deviceId = this.videoInputDevicesArray[1].deviceId;
            console.log(this.deviceId);
          } else {
            this.deviceId = this.videoInputDevicesArray[0].deviceId;
            console.log(this.deviceId);
          }
          this.decodeFromInputVideoFunc();
        })
        .catch(() => {
          this.tipShow = false;
        });
    },
    // 开始解码
    decodeFromInputVideoFunc() {
      if (this.videoInputDevicesArray.length == 0) {
        this.textContent = "初始化摄像头失败";
        document.getElementById("video").style.display = "none";
        return;
      }
      this.codeReader.reset();
      this.codeReader.decodeFromInputVideoDeviceContinuously(
        this.deviceId,
        "video",
        (result) => {
          this.tipMsg = "正在扫描";
          if (result) {
            if (result.text) {
              console.log("扫描成功", result.text);
              this.equipment = result.text;
              // this.confirmFn();
              this.tipMsg = "扫描成功";
              this.showvideo = false;
              this.tipShow = true;
              window && window.getResultEvent(result);
              // window?.parent?.Gikam?.toast("扫码成功");
              // 关闭扫码功能
              this.codeReader.reset();
              this.codeReader.stopContinuousDecode();
            }
          }
        }
      );
    },
    cutover() {
      if (
        this.videoInputDevicesArray &&
        this.videoInputDevicesArray.length > 1
      ) {
        if (this.deviceId === this.videoInputDevicesArray[0].deviceId) {
          return (this.deviceId = this.videoInputDevicesArray[1].deviceId);
        } else {
          return (this.deviceId = this.videoInputDevicesArray[0].deviceId);
        }
      }
      this.codeReader.stopStreams();
      return;
    },
    // 切换摄像头
    async toggle() {
      this.codeReader.stopStreams();
      this.timer = setTimeout(() => {
        this.timer = null;
      }, 2000);
      if (this.timer) {
        await this.codeReader.tryPlayVideo("video");
        this.cutover();
        this.decodeFromInputVideoFunc();
      }
    },
    colose() {
      this.showvideo = false;
    },
  },
};
</script>

<style>
.el-select-dropdown__list {
  background: #eee;
}

.el-select-dropdown__item {
  font-size: 0.25rem;
  height: 0.5rem;
  line-height: 0.5rem;
}
</style>
<style scoped lang="less">
@deep: ~">>>";

.login {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  .left {
    width: 50%;
    // height: 100%;
    // background: #575b7b url("../assets/img/bg11.png") no-repeat center center fixed;
    background: url("../assets/img/bg11.png") no-repeat left fixed;
    // -webkit-background-size: cover;
    // -moz-background-size: cover;
    // -o-background-size: cover;
    // background-size: cover;
    -webkit-background-size: 50%;
    -moz-background-size: 50%;
    -o-background-size: 50%;
    background-size: 50%;
    padding: 0;
    opacity: 0.9;

    // text-align: center;
    h1 {
      font-size: 48px;
      margin-top: 50%;
    }
  }

  .btn {
    width: 63%;
    margin-top: 0.8rem;
    margin-left: 1.9rem;

    .el-button {
      width: 100%;
      font-size: 0.25rem;
      color: #fff !important;
      background: #5093fc;
      border: 0;
      border-radius: 0;
    }
  }

  .max {
    width: 50%;
    // height: 100%;
    text-align: center;
    background: #fff;

    //position: relative;
    img {
      position: absolute;
      // left:0;
      right: 0;
      width: 1.2rem;
      color: #5093fc;
    }

    border: 1px solid #c1c1c1;

    .top {
      width: 60%;
      margin: 3.1rem auto 1.6rem;

      .littlefont {
        color: #5093fc !important;
        font-size: 0.68rem;
        line-height: 1rem;
        letter-spacing: 6px;
      }

      // img {
      //   width: 1.4rem;
      //   color: #5093fc;
      // }
    }

    .code {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      margin: 0 auto;
      margin-top: 0.6rem;
      border-bottom: 1px solid #c1c1c1;

      .el-switch {
        margin: 0 0 0 -42px;
      }

      .el-select {
        width: 85%;
      }

      // img {
      //   width: 0.5rem;
      //   height: 0.5rem !important;
      //   line-height: 0.2rem !important;
      // }

      @{deep} .el-input__inner {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.25rem;
        border: 0;
      }

      .ico1 {
        font-size: 0.4rem;
        margin-right: 0.2rem;
        color: #5093fc;
      }

      @{deep} .el-input {
        width: 80%;
        margin-left: 5px;

        .el-input__inner {
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 0.2rem;
        }

        .el-input-group__append {
          right: 0.2rem;
          width: 0.5rem;
          height: 0.5rem !important;
          padding: 0;
          background: #fff !important;
          border: 0;
        }
      }

      img {
        width: 0.5rem;
        height: 0.5rem !important;
        top: -0.1rem;
        background: #3c76ec;
      }
    }

    @{deep} .el-input__icon {
      line-height: 0;
    }
  }

  @{deep} .el-switch.is-checked .el-switch__core {
    color: #5093fc;
    border: 0;
    background: #5093fc !important;
  }
}

.code-reader-content {
  .page {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;

    #video {
      height: 100%;
      width: 100%;
      object-fit: fill;
    }
  }

  .scan-box {
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -90%);
    height: 30%;
    width: 70%;

    .frame {
      position: absolute;
      width: 15px;
      height: 15px;
      border: 3px solid transparent;
    }

    .upper-left {
      top: 0;
      left: 0;
      border-left-color: rgba(66, 133, 244, 1);
      border-top-color: rgba(66, 133, 244, 1);
    }

    .upper-right {
      top: 0;
      right: 0;
      border-right-color: rgba(66, 133, 244, 1);
      border-top-color: rgba(66, 133, 244, 1);
    }

    .lower-right {
      bottom: 0;
      right: 0;
      border-bottom-color: rgba(66, 133, 244, 1);
      border-right-color: rgba(66, 133, 244, 1);
    }

    .lower-left {
      bottom: 0;
      left: 0;
      border-left-color: rgba(66, 133, 244, 1);
      border-bottom-color: rgba(66, 133, 244, 1);
    }

    .pointer-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 98%;
      height: 100%;
      overflow: hidden;

      .pointer {
        height: 3px;
        background-image: linear-gradient(
          to right,
          transparent 0%,
          #afa 50%,
          transparent 100%
        );
        transform: translateY(-3px);
        animation: move 2s linear infinite;
      }

      @keyframes move {
        0% {
          transform: translateY(-3px);
        }

        100% {
          transform: translateY(calc(20vh - 3px));
        }
      }
    }

    .tip {
      position: absolute;
      left: 50%;
      top: 120%;
      transform: translate(-50%, 0);
      white-space: nowrap;
      // color: rgb(85, 209, 28);
      color: red;
      font-size: 16px;
    }

    .btn-switch {
      position: absolute;
      left: 50%;
      top: 140%;
      width: 50px;
      height: 20px;
      transform: translate(-50%, 0);
      background-color: #aaf;
      color: #fff;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      // background: url('../../../img/icon/switch.svg') no-repeat center;
    }
  }
}
</style>
